module.exports = __webpack_public_path__ + "static/media/banner-offer-pro.a3a5f800.png";